<template>
    <component
        :is="disabled ? 'span' : 'a'"
        :title="text"
        :href="url"
        :class="[`font-roboto font-${weight} text-slate-600 mr-1`]"
    >
        <i
            v-if="icon"
            :class="['align-middle icon', iconSize === 'sm' ? 'h-4 w-4' : 'h-5 w-5', icon]"
        >
        </i>
        {{ text }}
    </component>
</template>

<script>
export default {
    name: 'TagContainer',
    props: {
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            default: '',
        },
        count: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            default: '',
        },
        iconSize: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        weight: {
            type: String,
            default: 'medium',
            validator: (value) => {
                return [
                    'extra-light',
                    'light',
                    'normal',
                    'medium',
                    'bold',
                    'extra-bold',
                    'black',
                ].includes(value);
            },
        },
    },
    computed: {
        text() {
            return this.count ? `${this.title} (${this.count})` : this.title;
        },
    },
};
</script>
